module.exports = __webpack_public_path__ + "img/1 (102).019ba6c3.png";